import type { Action, Tournament } from '../../types.js';
import { nextId } from '../../ids.js';
import { normalizeRules } from '../../rules/validate.js';
import { EngineError } from '../state.js';
import { clone } from '../../clone.js';
import { competition, uebernehmen } from './shared.js';

/** Turnier und Bewerb: Stammdaten, Status, Pause, Regelwerk */

const TURNIER_FELDER = ['name', 'date', 'location', 'organizer', 'entryFee'] as const;
const REGEL_FELDER = [
  'teamSize',
  'matchFormat',
  'target',
  'winBy',
  'cap',
  'bust',
  'maxInnings',
  'timeLimitMin',
  'onLimit',
  'draws',
  'resultMode',
  'points',
  'tiebreakers',
  'walkover',
  'plannedMatchMinutes',
  'minRestMinutes',
] as const;

export function applyTournament(t: Tournament, action: Action): string[] {
  const warnings: string[] = [];
  switch (action.type) {
    case 'tournament.update':
      if (action.patch.entryFee !== undefined && action.patch.entryFee < 0) throw new EngineError('Startgeld muss ≥ 0 sein');
      uebernehmen(t, action.patch, TURNIER_FELDER);
      break;
    case 'tournament.setStatus':
      t.status = action.status;
      break;
    case 'tournament.pause': {
      if (action.until !== undefined && action.until > (action.at ?? 0)) t.pausedUntil = action.until;
      else delete t.pausedUntil;
      break;
    }

    // Regelwerke aus alten Protokollen können Werte tragen, die es nicht mehr gibt — `normalizeRules`
    case 'competition.add':
      t.competitions.push({ id: nextId(t, 'cp'), name: action.name, ruleSet: normalizeRules(clone(action.ruleSet)), status: 'setup', teams: [], phases: [] });
      break;
    case 'competition.updateRules':
      uebernehmen(competition(t, action.competitionId).ruleSet, normalizeRules(action.patch), REGEL_FELDER);
      break;
  }
  return warnings;
}
